/* eslint-disable */
// Season vocabularies. TWO rules live here, deliberately, because CREATION and
// FILTERING answer different questions:
//
//   seasonCreateOptions(devFields) → what a user may CHOOSE when creating.
//   deriveSeasonOptions(devs)      → what already EXISTS in the data (filters).
//
// ── CREATION (David, 2026-08-13) ───────────────────────────────────────────
// Reads dev_settings.devFields['season'].options and NOTHING ELSE. No
// DEV_SEASONS fallback, no data derivation: if Settings holds no season
// options the dropdown is EMPTY. David chose "empty over Summer/Winter".
//
// This REVERSES the 2026-06-24 decision (commit cc27737), which derived the
// creation list from data because devFields['season'] then held only the bare
// DEV_SEASONS constant ("Winter"/"Spring"/"Summer"/"Fall") — offering it would
// have written a value no other surface could match. That premise is now
// FALSE: David curates the real vocabulary in Settings → Schema → Fields
// ("SUNGLASSES SUMMER 2028", "OPTIC 2028", …), so the constant is no longer
// what devFields contains and the hazard is gone. Deriving from data had the
// opposite cost — a season could never be used for the first time from the
// create form, and legacy echoes ("Summer", "Winter") were offered forever.
// Full evidence: docs/audit/devform-options-source.md (commit 24c9af56).
//
// Consumed by DevFormModal2 and useCreateOptions.useSeasonOptions, so both
// creation forms offer the identical list from ONE definition.
export function seasonCreateOptions(devFields) {
  const f = (devFields || []).find((x) => x && x.key === 'season');
  return Array.isArray(f && f.options) ? f.options.filter(Boolean) : [];
}

// ── FILTERING (unchanged — Convention #145) ────────────────────────────────
// Distinct data.season values, ordered by frequency, names only. A filter must
// offer what EXISTS or it would list options matching zero rows, so this stays
// data-derived and must NOT be pointed at devFields.
//
// Consumed by:
//   - DevsActionBar.js → Board Season filter (appends a `_no_season` sentinel)
export function deriveSeasonOptions(devs) {
  const freq = new Map();
  for (const d of (devs || [])) {
    const v = (d?.season || d?.data?.season || '').toString().trim();
    if (v) freq.set(v, (freq.get(v) || 0) + 1);
  }
  return [...freq.entries()]
    .sort((a, b) => b[1] - a[1])              // count desc
    .map(([v]) => ({ value: v, label: v }));  // names only, no counts
}
